(function() {
'use strict';

angular.module('TR')
    .service('breadcrumbDetailsService', breadcrumbDetailsService);

function breadcrumbDetailsService(resourceService, tripService, $routeParams, basketService) {
    const service = {
        getClasses,
        getText,
        getCrumbs,
        getTextShort
    };

    function getClasses(bc) {
        return function(c) {
            let currentCrumb = basketService.isFlightPreselected() && bc.crumb === 10 ? 25 : bc.crumb;
            return c < currentCrumb ? 'done' : c === currentCrumb ? 'is-active' : '';
        };
    }

    function getText() {
        return {
            0: resourceService.getDeferred('BREADCRUMBHOME'),
            5: resourceService.getDeferred('BREADCRUMBDEAL'),
            10: resourceService.getDeferred('BREADCRUMBFLIGHT'),
            20: resourceService.getDeferred('BREADCRUMBHOTEL'),
            21: resourceService.getDeferred('BREADCRUMBROOM'),
            25: resourceService.getDeferred('BREADCRUMBCHANGEFLIGHT'),
            30: resourceService.getDeferred('BREADCRUMBTRANSFER'),
            35: resourceService.getDeferred('BREADCRUMBPARKING'),
            40: resourceService.getDeferred('BREADCRUMBEXTRAS'),
            50: resourceService.getDeferred('BREADCRUMBPAYMENT')
        };
    }

    function getTextShort() {
        return {
            0: resourceService.getDeferred('BREADCRUMBHOMESHORT'),
            20: resourceService.getDeferred('BREADCRUMBHOTELSHORT'),
            21: resourceService.getDeferred('BREADCRUMBROOMSHORT'),
            25: resourceService.getDeferred('BREADCRUMBCHANGEFLIGHTSHORT'),
            40: resourceService.getDeferred('BREADCRUMBEXTRASSHORT'),
            50: resourceService.getDeferred('BREADCRUMBPAYMENTSHORT')
        };
    }

    function getCrumbs() {
        return tripService.getTrip($routeParams.tripId).then(function(trip) {
            if (trip && trip.Deal) {
                return [5, 21, 50];
            }
            if ((basketService.isFlightPreselected() && trip.TripType === tripService.tripTypes.Holiday) ||
            TRPCONFIG.Domain2.IsHotelFirstJourneyEnabled) {
                return [0, 20, 21, 25, 40, 50];
            }
            switch (trip.TripType) {
                case 1: //flight
                    return [0, 10, 40, 50];
                case 2: //hotel
                    return [0, 20, 21, 50];
                case 3: //transfer
                    return [0, 30, 50];
                case 4: //holiday
                    return [0, 10, 20, 21, 40, 50];
                case 5: // marhaba
                    return []; // ?
                case 6: // parking
                    return [0, 35, 50];
                default:
                    return [];
            }
        });
    }

    return service;
}
})();
